import styled from "styled-components";

import { DIGIPOSTHEME } from "theme/digiPosTheme";
import { MEDIA_QUERIES } from "context/media/MediaConstant";

import { InformationProps } from "./SecurityColumn.constants";

export const StyledOuterContainer = styled.div`
  width: 200px;

  margin-left: 24px;

  border-radius: 8px;

  @media ${MEDIA_QUERIES.MOBILE} {
    width: 100%;

    margin: 10px 0 32px 0;

    border-radius: 0;
  }
`;

export const StyledPasswordContainer = styled.div`
  padding: 20px 16px;

  background-color: ${DIGIPOSTHEME.colors.headerRed};

  border-top-left-radius: 8px;
  border-top-right-radius: 8px;

  @media ${MEDIA_QUERIES.MOBILE} {
    padding: 24px 20px;

    border-radius: 0;
  }
`;

export const StyledInformationText = styled.div`
  padding-bottom: 16px;
  margin-right: 16px;

  color: ${DIGIPOSTHEME.colors.white};

  font-family: Campton;
  font-size: 14px;
  line-height: 1.43;

  @media ${MEDIA_QUERIES.MOBILE} {
    padding-bottom: 24px;
    margin-right: 38px;
  }
`;

export const StyledPasswordText = styled.div`
  padding-bottom: 4px;

  color: ${DIGIPOSTHEME.colors.white};

  font-family: Campton;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.33;
  letter-spacing: 0.23px;

  @media ${MEDIA_QUERIES.MOBILE} {
    padding-bottom: 16px;
  }
`;

export const StyledSecurityContainer = styled.div<InformationProps>`
  border-radius: ${({ passwordFieldIsOpen }) =>
    passwordFieldIsOpen ? "0 0 8px 8px" : "8px"};

  background-color: ${DIGIPOSTHEME.colors.white};
`;

export const StyledSecurityText = styled.div<InformationProps>`
  padding: 24px 0 8px 16px;

  border-radius: ${({ passwordFieldIsOpen }) =>
    passwordFieldIsOpen ? 0 : "8px 8px 0 0"};

  color: ${DIGIPOSTHEME.colors.secondaryAkbankBlack};
  background-color: #f8f8f8;

  font-family: Campton;
  font-size: 18px;
  font-weight: 500;
  line-height: 1.33;
  letter-spacing: 0.23px;

  @media ${MEDIA_QUERIES.MOBILE} {
    padding: 24px 0 8px 20px;
  }
`;

export const StyledSecurityInformationContainer = styled.div<InformationProps>`
  padding: 0px 0px 16px 16px;

  border-radius: ${({ passwordFieldIsOpen }) =>
    passwordFieldIsOpen ? "0 0 8px 8px" : "0 0 8px 8px"};

  background-color: ${DIGIPOSTHEME.colors.white};

  @media ${MEDIA_QUERIES.MOBILE} {
    padding: 0 20px;
  }
`;

export const StyledSecurityInformationText = styled.div`
  padding: 16px 22px 10px 0;
  margin-right: 16px;

  border-bottom: 1px solid ${DIGIPOSTHEME.colors.secondaryGrayTertiary};

  font-family: Campton;
  font-size: 12px;
  line-height: 1.33;
  letter-spacing: 0.4px;
  color: ${DIGIPOSTHEME.colors.secondaryGrayPrimary};

  @media ${MEDIA_QUERIES.MOBILE} {
    padding: 16px 28px 16px 0;
  }
`;

export const LinkWrapper = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  padding: 16px 19px 0 10px;

  color: ${DIGIPOSTHEME.colors.headerRed};

  font-family: Campton;
  font-size: 14px;
  font-weight: 500;
  line-height: 1.43;
  letter-spacing: 0.5px;
  text-decoration: none;

  @media ${MEDIA_QUERIES.MOBILE} {
    padding: 24px 20px 16px 0;
  }
`;
